import React from "react";

const RoomListItems = ({ items, onNewBed }) => {
	const list = items || [];

	if (list.length < 1)
		return (
			<div className="text-center fade-in text-pink">
				<h4>No room added yet!</h4>
			</div>
		);

	return (
		<div className="panel-group accordion" id="accordion3">
			{list.map((item, key) => (
				<div
					key={key}
					className="panel panel-default no-formatting-panel"
				>
					<div className="panel-heading panel-heading-gray">
						<h4 className="panel-title">
							<a
								className="accordion-toggle accordion-toggle-styled"
								data-toggle="collapse"
								data-parent="#accordion3"
								href={`#${item.id}`}
							>
								Room: <strong>{item.name}</strong>
							</a>
						</h4>
					</div>
					<div id={item.id} className="panel-collapse in">
						<div className="panel-body">
							<h4>Description:</h4>
							<p>
								{item.description || "No description supplied!"}
							</p>
							<h4>Beds:</h4>
							<table className="table table-inbox table-hover">
								<tbody>
									{item.beds.map((bed, idx) => (
										<tr key={idx}>
											<td className="inbox-small-cells">
												<div className="todo-check pull-left">
													{idx + 1}
												</div>{" "}
											</td>
											<td className="view-message">
												<p
													title={` Created at ${new Date(
														parseInt(bed.created_at)
													).toLocaleDateString(
														"en-GB"
													)} `}
												>
													{bed.name}
												</p>{" "}
											</td>
											<td className="view-message inbox-small-cells">
												<p>
													{bed.description ||
														"No Description!"}
												</p>{" "}
											</td>
										</tr>
									))}
								</tbody>
							</table>
							{item.beds.length < 1 && (
								<div className="text-center">
									<h4>No bed is added yet!</h4>
								</div>
							)}
							<div className="text-center m-t-20">
								<button
									type="button"
									onClick={() => onNewBed(item)}
									className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
								>
									New Bed
								</button>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default RoomListItems;
